import React from 'react';
import { FAQAccordion } from '../components/faq/FAQAccordion';
import { PrivacySection } from '../components/faq/PrivacySection';
import { TimelineSection } from '../components/faq/TimelineSection';
export function FAQPage() {
  return <div className="w-full bg-gray-50" data-id="element-316">
      <div className="container mx-auto px-4 py-16" data-id="element-317">
        <h1 className="text-4xl font-bold text-center mb-4" data-id="element-318">
          Frequently Asked Questions
        </h1>
        <p className="text-lg text-gray-600 text-center mb-12 max-w-2xl mx-auto" data-id="element-319">
          Find answers to common questions about the Testbed Schools Initiative.
        </p>
        <div className="max-w-3xl mx-auto space-y-12" data-id="element-320">
          <FAQAccordion data-id="element-321" />
          <PrivacySection data-id="element-322" />
          <TimelineSection data-id="element-323" />
        </div>
      </div>
    </div>;
}